import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';
import ReactTable from "react-table";
import Moment from 'moment';
import ModuloEfd from './../Modulo/ModuloEfd';
import PesquisaRapida from './../PesquisaRapida/PesquisaRapida';
import HttpUtil from '../../Util/httpUtil';
import OpcoesDownloadItem from './../Modulo/OpcoesDownloadItem';
import RemoverResultadoItem from './../Modulo/RemoverResultadoItem';
import BotaoImportacao from './BotaoImportacao';
import ModalNotificacaoArquivosRecentes from './ModalNotificacaoArquivosRecentes';
import EnviarArquivos from './../Arquivos/EnviarArquivos';
import Config from '../../Util/config';
import '../../_Content/css/resultado.css';
import '../../_Content/css/eco-template.css';
import "react-table/react-table.css";
import { withRouter } from "react-router-dom";

// SignalR loaded via CDN in index.html — available as window.signalR
const signalR = window.signalR;

const idUsuario = localStorage.getItem("CodUsuario");
const token = localStorage.getItem("Token");
const isSimulacao = localStorage.getItem("isSimulacao") === 'true';
let _ultimaIdAnaliseCont = 0;
let _ultimaIdAnaliseFiscal = 0;
let _ultimaIdAnaliseEcf = 0;
let _ultimaIdAnaliseEcd = 0;

class ArquivosRecentes extends Component {
	constructor(props) {
		super(props);

		this.state = {
			pageSize: 10,
			textoPesquisar: '',
			lista: [],
			listaFiltrada: [],
			listaEmpresas: [],
			listaCompetencias: [],
			listaValidacoes: [{
				Key: "basica",
				Value: "Básica",
			}, {
				Key: "estados",
				Value: "Estados",
			}, {
				Key: "inteligente",
				Value: "Inteligente",
			}, {
				Key: "simples-nacional",
				Value: "Simples Nacional",
			}],
			mostrarContribuicoes: true,
			mostrarECF: true,
			mostrarECD: true,
			mostrarFiscal: true,
			mostrarSimplesNacional: true,
			loading: true,
			mostrarPaginacao: false,
			pageSize: 10,
			numberPages: 0,
			filtroModulo: "todos",
			filtroContribuinte: "todos",
			filtroCompetencia: "todos",
			filtroDe: "",
			filtroAte: "",
			filtroValidacoes: "todos",
			exibirNotificacao: localStorage.getItem("ExibirNotificacaoArquivosRecentes") == 'true',
			modalUpload: false,
			showFilter: false,
			columns: [{
				Header: "Módulo",
				accessor: "moduloEfd",
				maxWidth: 140,
				Cell: row => (
					<ModuloEfd
						value={row.original.tipoValidacao.includes('simples-nacional') ? 'SimplesNacional' : row.value} />)
			}, {
				Header: "Empresa",
				className: "txt",
				accessor: "Contribuinte"
			},
			{
				Header: "CNPJ",
				className: "text-center txt",
				accessor: "CnpjCpf",
				maxWidth: 120,
			},{
				Header: "Competência",
				accessor: "DatIni",
				className: 'text-center txt',
				maxWidth: 120,
				Cell: row => (
					<span>
						{row.value != "01/01/1900" ?
                            row.original.moduloEfd.toLowerCase() == "ecf"
                                || row.original.moduloEfd.toLowerCase() == "ecd" ?
								Moment(row.value, 'D/M/YYYY').format('Y') : Moment(row.value, 'D/M/YYYY').format('MMM - Y')
							: " - "
						}
					</span>)
			}, {
				Header: "Última atualização",
				accessor: "dataFormat",
				className: 'text-center txt',
				maxWidth: 140,
				Cell: row => (
					<span>{Moment(row.value).format("D/MM/Y [às] HH[h]mm")}</span>)
			}, {
				Header: "Divergências",
				accessor: "totalDivergencias",
				className: 'text-center txt',
				maxWidth: 100,
				Cell: row => (
					<span>{(row.original.status === 'Finalizado' || row.original.status === 'ErroEstrutura') ? row.original.totalDivergencias : 0}</span>)
			}, {
				Header: "Ações",
				accessor: "status",
				maxWidth: 70,
				className: 'text-center',
				Cell: row => (
					<div>
						<OpcoesDownloadItem idArquivo={row.original.id} moduloEfd={row.original.moduloEfd}
							tipoValidacao={row.original.tipoValidacao} status={row.original.status} origem={'arquivos'} />
						{/* <RemoverResultadoItem idArquivo={row.original.id} moduloEfd={row.original.moduloEfd}
							action={this.prepararRequestData} onLoading={this.onLoading} />
							Removido a pedido de Viviane 05/12/2019*/}
					</div>)
			}, {
				Header: "",
				maxWidth: 120,
				className: 'text-center colBtns',
				Cell: row => (<BotaoImportacao key={row.original.id}
					action={this.prepararRequestData}
					onLoading={this.onLoading}
					data={row.original}
					atualizarDivergencias={this.atualizarDivergencias} />)
			}]
		};

		this.prepararRequestData();
		this.buscarUltimaIdAnalise("Fiscal").then(resposta => {
			_ultimaIdAnaliseFiscal = resposta != 0 ? resposta.idUltimaAnalise : _ultimaIdAnaliseFiscal;
		});
		this.buscarUltimaIdAnalise("Contribuicao").then(resposta => {
			_ultimaIdAnaliseCont = resposta != 0 ? resposta.idUltimaAnalise : _ultimaIdAnaliseCont;
		});
		this.buscarUltimaIdAnalise("ECF").then(resposta => {
			_ultimaIdAnaliseEcf = resposta != 0 ? resposta.idUltimaAnalise : _ultimaIdAnaliseEcf;
		});
		this.buscarUltimaIdAnalise("ECD").then(resposta => {
			_ultimaIdAnaliseEcd = resposta != 0 ? resposta.idUltimaAnalise : _ultimaIdAnaliseEcd;
		});

		this._connection = new signalR.HubConnectionBuilder()
			.withUrl(Config.urls.SIGNALR_HUB_URL)
			.withAutomaticReconnect()
			.build();

		this._connection.start().then(() => {
			this._connection.invoke('JoinGrupoUsuario', parseInt(idUsuario));
		});

		this._connection.on('AtualizarArquivosRecentes', (ultimoIdAnalise, ultimoIdAnaliseFiscal, ultimaIdAnaliseEcf, ultimaIdAnaliseEcd) => {
			if ((_ultimaIdAnaliseCont != 0 && ultimoIdAnalise != _ultimaIdAnaliseCont) ||
				(_ultimaIdAnaliseFiscal != 0 && ultimoIdAnaliseFiscal != _ultimaIdAnaliseFiscal) ||
				(_ultimaIdAnaliseEcf != 0 && ultimaIdAnaliseEcf != _ultimaIdAnaliseEcf) ||
				(_ultimaIdAnaliseEcd != 0 && ultimaIdAnaliseEcd != _ultimaIdAnaliseEcd)) {
				_ultimaIdAnaliseCont = ultimoIdAnalise;
				_ultimaIdAnaliseFiscal = ultimoIdAnaliseFiscal;
				_ultimaIdAnaliseEcf = ultimaIdAnaliseEcf;
				_ultimaIdAnaliseEcd = ultimaIdAnaliseEcd;
				this.prepararRequestData();
			}
		});

		this._connection.onreconnected(() => {
			this._connection.invoke('JoinGrupoUsuario', parseInt(idUsuario));
		});
	}

	onLoading = (isLoading) => {
		this.setState({ loading: isLoading });
	}

	atualizarDivergencias = (id, divergencia) => {
		let lista = [];
		for (let indice in this.state.listaFiltrada) {
			let indiceTemp = null;
			indiceTemp = this.state.listaFiltrada[indice];
			if (this.state.listaFiltrada[indice].id == id)
				indiceTemp.totalDivergencias = divergencia;
			lista.push(indiceTemp);
		}
		this.setState({ listaFiltrada: lista });
	}

	componentWillUnmount() {
		//desconecta ao desmontar o componente
		if (this._connection) this._connection.stop();
	}

	requestData = () => {
		return new Promise((resolve, reject) => {
			let urlApi = `${Config.urls.API_URL_BASE}HistoricoArquivos/ListaResultadosRecentes/${idUsuario}`;

			if (token)
				urlApi += '/' + token;

			HttpUtil.eco_GET(urlApi, (response) => {
				resolve({ rows: response.data });
			}, () => {
				console.log("Error ExibirErrosEstrutura");
			});
		});
	};

	buscarUltimaIdAnalise = (modulo) => {
		return new Promise((resolve, reject) => {
			let urlApi = `${Config.urls.API_URL_BASE}HistoricoArquivos/BuscarUltimoIdAnalisePorUsuario/${modulo}/${idUsuario}`;

			if (token)
				urlApi += '/' + token;

			HttpUtil.eco_GET(urlApi, (response) => {
				resolve({ idUltimaAnalise: response.data });
			}, () => {
				console.log("Error ExibirErrosEstrutura");
			});
		});
	};

	prepararRequestData = () => {
		this.setState({ loading: true });
		this.requestData().then(res => {

			var empresas = res.rows.map(item => {
				return item.Contribuinte
			});

			var uniqueEmpresas = Array.from(new Set(empresas)).sort((a, b) => a.localeCompare(b));

			var competencias = res.rows.map(item => {
				return Moment(item.DatIni, "D/M/YYYY").format("YYYY")
			});

			var uniqueCompetencias = Array.from(new Set(competencias)).sort((a, b) => a.localeCompare(b));

			var validacoes = res.rows.map(item => {
				return item.tipoValidacao
			});

			var uniqueValidacoes = Array.from(new Set(validacoes)).sort((a, b) => a.localeCompare(b));

			this.setState({
				lista: res.rows,
				listaFiltrada: res.rows,
				loading: false,
				mostrarPaginacao: Object.keys(res.rows).length > 1000,
				listaEmpresas: uniqueEmpresas,
				listaCompetencias: uniqueCompetencias,
				numberPages: Math.round(res.rows / this.state.pageSize)
			});

			if (!res.rows.length && !this.state.exibirNotificacao && !isSimulacao)
				this.toggleModalUpload();

			var total = this.state.listaFiltrada.length;
			if (total < res.rows.length) {
				window.location.reload();
			}
		});
	};

	moduloClicado = (modulo, checked) => {
		switch (modulo) {
			case 'ECF':
				this.setState({ mostrarECF: checked }, this.atualizarListaFiltrada);
				break;
			case 'ECD':
				this.setState({ mostrarECD: checked }, this.atualizarListaFiltrada);
				break;
			case 'Fiscal':
				this.setState({ mostrarFiscal: checked }, this.atualizarListaFiltrada);
				break;
			case 'SimplesNacional':
				this.setState({ mostrarSimplesNacional: checked }, this.atualizarListaFiltrada);
				break;
			default:
				this.setState({ mostrarContribuicoes: checked }, this.atualizarListaFiltrada);
		}
	}

	updateListaFiltrada = () => {
		var newlistaFiltrada = [];

		for (var i in this.state.lista) {

			if (this.state.lista[i].tipoValidacao.includes('simples-nacional')) {
				if (this.state.mostrarSimplesNacional) {
					newlistaFiltrada.push(this.state.lista[i]);
				}
			}
			if (this.state.lista[i].moduloEfd === 'Contribuicao') {
				if (this.state.mostrarContribuicoes) {
					newlistaFiltrada.push(this.state.lista[i]);
				}
			}
			if (this.state.lista[i].moduloEfd === 'ECF') {
				if (this.state.mostrarECF) {
					newlistaFiltrada.push(this.state.lista[i])
				}
			}
			if (this.state.lista[i].moduloEfd === 'ECD') {
				if (this.state.mostrarECD) {
					newlistaFiltrada.push(this.state.lista[i])
				}
			}
			if (this.state.lista[i].moduloEfd === 'Fiscal') {
				if (this.state.mostrarFiscal) {
					newlistaFiltrada.push(this.state.lista[i])
				}
			}
		}
		this.setState({ listaFiltrada: newlistaFiltrada });
	}

	atualizarFiltroModulo = (event) => {

		var mostrarECF = false;
		var mostrarECD = false;
		var mostrarFiscal = false;
		var mostrarContribuicoes = false;
		var mostrarSimplesNacional = false;

		switch (event.target.value) {
			case "ECF":
				mostrarECF = true;
				break;
			case "ECD":
				mostrarECD = true;
				break;
			case "fiscal":
				mostrarFiscal = true;
				break;
			case "contribuicao":
				mostrarContribuicoes = true;
				break;
			case "simples-nacional":
				mostrarSimplesNacional = true;
				break;
			default:
				mostrarECF = true;
				mostrarECD = true;
				mostrarFiscal = true;
				mostrarContribuicoes = true;
				mostrarSimplesNacional = true;
				break;
		}
		this.setState({
			mostrarECF: mostrarECF,
			mostrarECD: mostrarECD,
			mostrarFiscal: mostrarFiscal,
			mostrarSimplesNacional: mostrarSimplesNacional,
			mostrarContribuicoes: mostrarContribuicoes,
			filtroModulo: event.target.value
		}, this.atualizarListaFiltrada);
	}

	atualizarFiltroEmpresa = (event) => {
		var list = this.state.listaFiltrada;

		this.setState({
			listaFiltrada: list.filter(item => {
				return item.Contribuinte == event.target.value
			})
		});
	}

	atualizarListaFiltrada = (data = this.state.lista) => {
		var contribuinte = this.state.filtroContribuinte;
		var competencia = this.state.filtroCompetencia;
		var filtroDe = this.state.filtroDe == "" ? "" : new Date(this.state.filtroDe);
		var filtroAte = this.state.filtroAte == "" ? "" : new Date(this.state.filtroAte);
		var filtroValidacoes = this.state.filtroValidacoes;
		var mostrarSimplesNacional = this.state.mostrarSimplesNacional;
		var mostrarECF = this.state.mostrarECF;
		var mostrarECD = this.state.mostrarECD;
		var mostrarFiscal = this.state.mostrarFiscal;
		var mostrarContribuicoes = this.state.mostrarContribuicoes;

		var lista = data.filter(item => {
			return (item.Contribuinte == contribuinte || contribuinte == "todos") &&
				((mostrarSimplesNacional && item.moduloEfd == "Fiscal" && item.tipoValidacao.includes("simples-nacional"))
					|| (mostrarFiscal && item.moduloEfd == "Fiscal" && !item.tipoValidacao.includes("simples-nacional"))
					|| (mostrarContribuicoes && item.moduloEfd == "Contribuicao")
					|| (mostrarECF && item.moduloEfd == "ECF")
                    || (mostrarECD && item.moduloEfd == "ECD")) &&
                (Moment(item.DatIni, "D/M/YYYY").format("MMM - Y") == competencia || competencia == "todos") &&
				(Moment(item.DatIni, "dd/MM/yyyy")._d >= filtroDe || filtroDe == "") &&
				(Moment(item.DatFin, "dd/MM/yyyy")._d <= filtroAte || filtroAte == "") &&
				((item.tipoValidacao.includes(filtroValidacoes)) || filtroValidacoes == "todos")
		});

		console.log(lista);

		this.setState({
			listaFiltrada: lista
		});
	}

	onUpdatePesquisarapida = (lista) => {
		this.setState({
			listaFiltrada: lista
		});

		this.atualizarListaFiltrada(lista);
	}

	limparFiltros = () => {

		this.state.mostrarContribuicoes = true;
		this.state.mostrarFiscal = true;
		this.state.mostrarSimplesNacional = true;
		this.state.filtroContribuinte = "todos";
		this.state.filtroCompetencia = "todos";
		this.state.filtroDe = "";
		this.state.filtroAte = "";
		this.state.filtroValidacoes = "todos";
		this.state.filtroModulo = "todos";

		this.atualizarListaFiltrada();
	}

	modalNotificacaoClosed = () => {
		if (!this.state.lista.length && !this.state.loading && !isSimulacao)
			this.toggleModalUpload();

		this.setState({ exibirNotificacao: false });
	}

	toggleModalUpload = () => {
		if (localStorage.getItem("TermoUso") === "true")
			this.setState({ modalUpload: !this.state.modalUpload });
	}

	render() {
		return (
			<div>
				<Container>
					<Row>
						<Col>
							<section className="cabecalho">
								<Row>
									<Col md={7}>
										<label className="page-title">Arquivos Recentes</label>
                                        <a href="/arquivos-recentes" className="link-atualizar">Atualizar</a>
									</Col>
									<Col md={5}>
										<PesquisaRapida lista={this.state.lista} onUpdate={this.onUpdatePesquisarapida} />
									</Col>
								</Row>
							</section>
							<section className="opcoes">
								<Row>
									<Col lg={1} className="modulosTpsLbl">
										<label>Módulos:</label>
									</Col>
								</Row>
								<Row>
									<Col xl={6} lg={7}>
										<div className="modulo">
											<Row>
												<Col lg={3} xs={4} className="text-nowrap">
													<ModuloEfd value="Contribuicao" onUpdate={this.moduloClicado} checkable />
												</Col>
												<Col lg={2} xs={3} className="text-nowrap">
													<ModuloEfd value="ECF" onUpdate={this.moduloClicado} checkable />
												</Col>
												{/* Descomentar quando o projeto ECD entrar em produção */}
												<Col lg={2} xs={3} className="text-nowrap">
													<ModuloEfd value="ECD" onUpdate={this.moduloClicado} checkable />
												</Col>
												<Col lg={2} xs={3} className="text-nowrap">
													<ModuloEfd value="Fiscal" onUpdate={this.moduloClicado} checkable />
												</Col>
												<Col lg={2} xs={3} className="text-nowrap">
													<ModuloEfd value="SimplesNacional" onUpdate={this.moduloClicado} checkable />
												</Col>
											</Row>
										</div>
									</Col>
									<Col xl={{ offset: 3, size: 2 }} lg={{ offset: 2, size: 2 }} xs={4}>
										<div className="exibir form-inline">
											<label>Exibir:</label>
											<select className="form-control" onClick={e => {
												this.setState({ pageSize: parseInt(e.target.value) })
											}}>
												<option value="10">10</option>
												<option value="25">25</option>
												<option value="50">50</option>
												<option value="100">100</option>
												<option value="1000">1000</option>
											</select>
										</div>
									</Col>
									<Col lg={1} xs={1}>
										<div className="filtrar" onClick={() => { this.setState({ showFilter: !this.state.showFilter }) }}>
											<i className="ecoico ecoico-filtro"></i>
											<span>Filtrar</span>
										</div>
									</Col>
								</Row>
								<section className={this.state.showFilter ? "filterSection active" : "filterSection"}>
									<Row>
										{/* <Col className="col-xs-4">
											<label>MÓDULO</label>
											<select className="ecoforms" onChange={(this.atualizarFiltroModulo)} value={this.state.filtroModulo}>
												<option selected value="todos">Todos...</option>
												<option value="contribuicao">Contribuições</option>
												<option value="fiscal">Fiscal</option>
												<option value="simples-nacional">Simples Nacional</option>
											</select>
										</Col> */}
										<Col md={4}>
											<label>EMPRESA</label>
											<select className="ecoforms" value={this.state.filtroContribuinte}
												onChange={e => { this.state.filtroContribuinte = e.target.value; this.atualizarListaFiltrada() }}>
												<option value="todos">Todos...</option>
												{this.state.listaEmpresas.map(item => (
													<option key={item} value={item}>
														{item}
													</option>
												))}
											</select>
										</Col>
										<Col md={3}>
											<label>COMPETÊNCIA</label>
											<select className="ecoforms" onChange={e => {
												this.state.filtroCompetencia = e.target.value;
												this.atualizarListaFiltrada()
											}} value={this.state.filtroCompetencia}>
												<option value="todos">Todas...</option>
												{this.state.listaCompetencias.map(item => (
													<option key={item} value={item}>
														{item}
													</option>
												))}
											</select>
										</Col>
										{/* <Col className="col-xs-6">
											<label>PERÍODO</label>
											<input className="ecoforms" type="date" value={this.state.filtroDe} onChange={e => {
												this.state.filtroDe = e.target.value;
												this.atualizarListaFiltrada()
											}} />
										</Col>
										<Col className="col-xs-6">
											<label>&nbsp;</label>
											<input className="ecoforms" type="date" value={this.state.filtroAte} onChange={e => {
												this.state.filtroAte = e.target.value;
												this.atualizarListaFiltrada()
											}} />
										</Col> */}
										<Col md={3}>
											<label>VALIDAÇÕES</label>
											<select className="ecoforms" value={this.state.filtroValidacoes} onChange={e => {
												this.state.filtroValidacoes = e.target.value;
												this.atualizarListaFiltrada()
											}}>
												<option value="todos">Todas...</option>
												{this.state.listaValidacoes.map(item => (
													<option key={item.Key} value={item.Key}>
														{item.Value}
													</option>
												))}
											</select>
										</Col>
										<Col md={2}>
											<button className="ecobtn fat vazado baby-blue limpaFiltro btn-block" onClick={this.limparFiltros}>Limpar Filtros</button>
										</Col>
									</Row>
								</section>
							</section>
							<section>
								<ReactTable
									key={this.state.pageSize}
									data={this.state.listaFiltrada}
									columns={this.state.columns}
									loading={this.state.loading}
									pageSize={this.state.pageSize}
									className="eco-react-table"
									showPagination={this.state.listaFiltrada.length > this.state.pageSize}
								/>
							</section>
						</Col>
					</Row>
					<ModalNotificacaoArquivosRecentes modal={this.state.exibirNotificacao} onClose={this.modalNotificacaoClosed} />
					<EnviarArquivos propModalUpload={this.state.modalUpload} fnToggleModalUpload={this.toggleModalUpload} />
				</Container>
			</div>
		);
	}
}

export default withRouter(ArquivosRecentes);


// WEBPACK FOOTER //
// ./src/Componente/Arquivos/ArquivosRecentes.jsx